export default __webpack_public_path__ + "static/media/background1.545aca60.png";